import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { useModuleTitle } from 'models/settings'

import { Text } from 'components/dataDisplay'
import { HeaderButton } from 'components/inputs'

import CountWithText from 'compositions/CountWithText/CountWithText'

import OtherAppealsSection from '../../../../../appeals/pages/components/OtherAppealsSection/OtherAppealsSection'

import shield from '../../images/votes@2x.png'
import megaphone from '../../images/appeals@2x.png'

import useAppeals from './util/useAppeals'
import useVotings from './util/useVotings'

import ModuleCard from './components/ModuleCard'


// eslint-disable-next-line max-len
const activeCitizenMessage = 'Решайте, каким станет город, на что будут расходоваться выделенные на городские инициативы бюджетные средства, принимая участие в опросах и голосованиях'
const problemsMessage = 'Если на дороге яма, не горит фонарь, не убран мусор или вы столкнулись с другой проблемой — сообщите о ней'
const votingMessage = 'Чтобы самому решать, каким станет город и куда будет расходоваться бюджет'

type ActiveCitizenBlockProps = {
  className?: string
  withProblems?: boolean
  withVoting?: boolean
}

const ActiveCitizenBlock: React.FC<ActiveCitizenBlockProps> = (props) => {
  const { className, withProblems, withVoting } = props
  const { appeals, appealsTotal, appealsInWork, appealsClosed } = useAppeals()
  const { votingsTotal } = useVotings({
    skip: !withVoting,
  })

  const { isMobile, isTablet, isDesktop } = useDevice()

  const withTwoModules = withProblems && withVoting

  const { title: appealsModuleTitle } = useModuleTitle('PROBLEMS')
  const { title: votingModuleTitle } = useModuleTitle('VOTING')

  return (
    <div className={cx(className)}>
      <div className={isMobile ? null : 'flex'}>
        <div className="flex-1">
          {
            withTwoModules ? (
              <Text
                message="Активный житель"
                size={isMobile ? 'h20-28' : 'h32'}
                color="titanic"
              />
            ) : withProblems ? (
              <HeaderButton
                size={isMobile ? 'h20-24' : 'h32'}
                title={appealsModuleTitle}
                to="/appeals"
              />
            ) : (
              <Text
                message={votingModuleTitle}
                size={isMobile ? 'h20-28' : 'h32'}
                color="titanic"
              />
            )
          }
          <Text
            className={cx('mt-16px opacity-72', isMobile ? null : isTablet ? 'mw-349' : 'mw-456')}
            message={withTwoModules ? activeCitizenMessage : withProblems ? problemsMessage : votingMessage}
            size="t16-24"
            color="gladiator"
          />
        </div>
        <div className={cx('relative', isTablet ? null : 'flex', isMobile ? 'mt-16px' : null)}>
          <CountWithText
            count={appealsTotal}
            text={withTwoModules ? 'Обращений принято' : withProblems ? 'Принято' : 'Проведено'}
          />
          {
            (withTwoModules || withProblems) && (
              <CountWithText
                className={isTablet ? 'mt-16px' : isMobile ? 'ml-24px' : 'ml-32px'}
                count={withTwoModules ? votingsTotal : appealsClosed}
                text={withTwoModules ? 'Голосований проведено' : 'Исполнено'}
              />
            )
          }
        </div>
      </div>
      {
        withTwoModules ? (
          <div className={cx('mt-40px', isDesktop ? 'flex justify-stretch' : '')}>
            <ModuleCard
              className="flex-1"
              title={appealsModuleTitle}
              icon={megaphone}
              text={problemsMessage}
              link="/appeals"
              appeals={appeals}
              appealsCount={appealsInWork}
            />
            <ModuleCard
              className={cx('flex-1', isDesktop ? 'ml-32px' : isTablet ? 'mt-40px' : 'mt-64px')}
              title={votingModuleTitle}
              icon={shield}
              text={votingMessage}
              link="/votings"
            />
          </div>
        ) : withProblems ? (
          <div className="flex mt-40px">
            <OtherAppealsSection />
          </div>
        ) : (
          <ModuleCard
            className="flex-1 mt-32px"
            title={votingModuleTitle}
            icon={shield}
            text={votingMessage}
            link="/votings"
          />
        )
      }
    </div>
  )
}

export default ActiveCitizenBlock